import React, { useMemo } from 'react';
import styled from 'styled-components';
export const DOT_LIST_DOT_CLASSNAME = 'dot-list-dot';
export const DotListContainer = styled.div `
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    color: ${(props) => props.theme.colors.textSecondary};

    .${DOT_LIST_DOT_CLASSNAME} {
        margin-right: 0.25rem;
        margin-left: 0.25rem;
    }
`;
export const DOT = React.createElement(React.Fragment, null, "\u00B7");
/**
 * Component to create horizontally composed components separated by dots in between.
 * All children will be separated by dots, this can be accomplished with mapping an array, creating elements, or any other React-y way of creating children.
 * Accepts any child (but typically are strings or elements that are string-like).
 * @param props @see DotListProps
 */
const DotList = ({ styledComponentOverride, children }) => {
    const Container = styledComponentOverride !== null && styledComponentOverride !== void 0 ? styledComponentOverride : DotListContainer;
    const componentList = React.Children.toArray(children);
    const renderDot = (index) => {
        return (React.createElement("span", { className: DOT_LIST_DOT_CLASSNAME, key: `${index}-dot` }, DOT));
    };
    const result = useMemo(() => {
        return componentList.map((component, index) => [
            React.createElement(React.Fragment, { key: index }, component),
            index !== componentList.length - 1 ? renderDot(index) : null
        ]);
    }, [componentList]);
    return React.createElement(Container, null, result);
};
export default DotList;
//# sourceMappingURL=index.js.map